import { useEffect, useState } from "react";
import { fetchStats } from "../lib/api";
import { Building2, Banknote, Users, MapPin, ShieldCheck } from "lucide-react";

const Cell = ({ label, value, icon: Icon, testid }) => (
  <div
    data-testid={testid}
    className="group relative border-r border-b border-[#0A0A0A] p-6 md:p-8 bg-white hover:bg-[#F8F9FA] transition-colors"
  >
    <div className="flex items-start justify-between mb-4">
      <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#4B5563]">
        {label}
      </span>
      <Icon className="w-4 h-4 text-[#4B5563] group-hover:text-[#002FA7] transition-colors" strokeWidth={2} />
    </div>
    <div className="font-display font-black text-3xl md:text-4xl lg:text-5xl tracking-tighter">
      {value}
    </div>
  </div>
);

export const StatsBar = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    fetchStats().then(setStats).catch(() => {});
  }, []);

  // Defensive: API could return an error shape or partial payload.
  // Every field is guarded so a single missing key can never crash the page.
  const fmt = (n) => (typeof n === "number" ? n.toLocaleString() : "—");

  return (
    <section id="stats" data-testid="stats-bar" className="border-b border-[#0A0A0A] bg-white">
      <div className="max-w-[1440px] mx-auto px-6 md:px-8 lg:px-12 py-12">
        <div className="flex items-baseline justify-between mb-6">
          <h2 className="font-display font-bold text-2xl md:text-3xl tracking-tight">
            Coverage <span className="text-[#4B5563]">/ today</span>
          </h2>
          <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#4B5563]">
            Auto-synced
          </span>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-5 border-t border-l border-[#0A0A0A]">
          <Cell testid="stat-banks"    label="Banks"        value={fmt(stats?.total_banks)}    icon={Banknote} />
          <Cell testid="stat-nbfcs"    label="NBFCs & ARCs" value={fmt(stats?.total_nbfcs)}    icon={Building2} />
          <Cell testid="stat-contacts" label="Contacts"     value={fmt(stats?.total_contacts)} icon={Users} />
          <Cell testid="stat-detailed" label="Verified"     value={fmt(stats?.total_detailed)} icon={ShieldCheck} />
          <Cell testid="stat-states"   label="States"       value={stats?.total_states ?? "—"} icon={MapPin} />
        </div>
      </div>
    </section>
  );
};
